// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__2bj3x","title":"styles_title__3sv-1","ripple":"styles_ripple__2Qp3m"};